exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._29oqv7lZi2AHN1HNINq7VD{font-size:12px;font-weight:400}html[dir] ._29oqv7lZi2AHN1HNINq7VD{margin-top:20px;margin-bottom:20px}._1VOfgH1-FDYFFJZco8zmNn{vertical-align:middle}._35i1AdKWszq6SVdd9o6PLa{color:\"[theme:neutralSecondary, default:#666666]\";vertical-align:middle}html[dir=ltr] ._35i1AdKWszq6SVdd9o6PLa{margin-left:7px}html[dir=rtl] ._35i1AdKWszq6SVdd9o6PLa{margin-right:7px}html[dir] ._2cOLXWI-omGMjt0an7y1Xr{margin-top:5px}.LKLb61DbC-bbgtCQyyR0e{color:\"[theme:neutralPrimary, default:#333333]\"}", ""]);
// Exports
exports.locals = {
	"panel": "_29oqv7lZi2AHN1HNINq7VD",
	"attachIcon": "_1VOfgH1-FDYFFJZco8zmNn",
	"attachmentCountLabel": "_35i1AdKWszq6SVdd9o6PLa",
	"attachmentCollectionContainer": "_2cOLXWI-omGMjt0an7y1Xr",
	"attachmentCollectionLabel": "LKLb61DbC-bbgtCQyyR0e"
};